module.exports = __webpack_public_path__ + "img/plane.d98bd2aa.png";